export const TENANT_ID = 'igi_insurance';
export const DEMO_TENANT_ID = TENANT_ID;
export const TENANT_COMPANY_NAME = 'Pulse Insurance';

/** Public branded slugs on this hosting. Always resolve to tenant id igi_insurance. */
export const PUBLIC_BRAND_SLUGS = ['pulse', 'pulse-insurance'];

export function normalizePublicSlug(slug) {
    return String(slug || '').trim().toLowerCase();
}

export function isPublicBrandSlug(slug) {
    return PUBLIC_BRAND_SLUGS.includes(normalizePublicSlug(slug));
}

/** Directory / book id for public pages. This hosting is Pulse Insurance only. */
export function publicTenantSlug(slug) {
    const s = normalizePublicSlug(slug);
    if (!s || s === 'login' || s === 'client' || s === 'verify') return TENANT_ID;
    if (isPublicBrandSlug(s) || s === TENANT_ID) return TENANT_ID;
    return TENANT_ID;
}
